export default "__VITE_ASSET__Dxu8vIL$__"